<template>
  <a
    v-if="articleCategory"
    class="text-sm font-medium hover:text-link-primary text-[#7F8083]"
    :href="articleCategory.route"
    v-bind="bind"
    @click.stop
  >
    {{ articleCategory.name }}
  </a>
</template>

<script>
import { computed, defineComponent, inject } from '@nuxtjs/composition-api';

export default defineComponent({
  props: {
    hp4uAttrs: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const article = inject('article', null);
    const articleCategory = computed(() => {
      if (article?.breadcrumb) return article.breadcrumb[article.breadcrumb.length - 1];
      else return article.categories[0];
    });

    // Taboola Hp4u Attrs
    const bind = props.hp4uAttrs ? { 'data-tb-category': '' } : {};

    return { articleCategory, bind };
  },
});
</script>
